import React from "react";
import "./styles/Skeleton.css";

export function SkeletonBlock({ className = "", style }) {
  return (
    <span className={`gw-skeleton ${className}`} style={style} aria-hidden="true" />
  );
}

function ListSkeletonRow() {
  return (
    <div className="gw-skeleton-row">
      <SkeletonBlock className="gw-skeleton-row__media" />
      <div className="gw-skeleton-row__body">
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--title" />
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--md" />
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--sm" />
      </div>
      <SkeletonBlock className="gw-skeleton-row__action" />
    </div>
  );
}

export function ListSkeleton({ count = 5 }) {
  return (
    <div className="gw-skeleton-list" aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }, (_, index) => (
        <ListSkeletonRow key={index} />
      ))}
    </div>
  );
}

export function AdDetailSkeleton() {
  return (
    <div className="gw-skeleton-ad" aria-busy="true" aria-label="Loading">
      <div className="gw-skeleton-ad__gallery">
        <div className="gw-skeleton-ad__thumbs">
          {Array.from({ length: 4 }, (_, index) => (
            <SkeletonBlock key={index} className="gw-skeleton-ad__thumb" />
          ))}
        </div>
        <SkeletonBlock className="gw-skeleton-ad__main" />
      </div>
      <div className="gw-skeleton-ad__info">
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--title" />
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--md" />
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--price" />
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--md" />
        <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--sm" />
        <SkeletonBlock className="gw-skeleton-ad__btn" />
        <div className="gw-skeleton-ad__seller">
          <SkeletonBlock className="gw-skeleton-circle" />
          <div className="gw-skeleton-ad__seller-body">
            <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--sm" />
            <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--xs" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function StoreSkeleton() {
  return (
    <div className="gw-skeleton-store" aria-busy="true" aria-label="Loading">
      <SkeletonBlock className="gw-skeleton-store__banner" />
      <div className="gw-skeleton-store__row">
        <div className="gw-skeleton-store__side">
          <SkeletonBlock className="gw-skeleton-circle gw-skeleton-circle--lg" />
          <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--md" />
          <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--sm" />
          <SkeletonBlock className="gw-skeleton-line gw-skeleton-line--sm" />
        </div>
        <div className="gw-skeleton-store__main">
          <ListSkeleton count={4} />
        </div>
      </div>
    </div>
  );
}

export default ListSkeleton;
